var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import { Dialog, DialogContent, AppBar, Toolbar, Typography, IconButton, } from '@mui/material';
import { CloseDialogIcon, BackIcon } from '../atoms/Icons';
import styled from 'styled-components';
var SubTitle = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  font-size: 12px;\n"], ["\n  font-size: 12px;\n"])));
var FullScreenDialog = function (_a) {
    var title = _a.title, subTitle = _a.subTitle, children = _a.children, open = _a.open, _b = _a.keepMounted, keepMounted = _b === void 0 ? false : _b, onClose = _a.onClose, onBack = _a.onBack, _c = _a.contentProps, contentProps = _c === void 0 ? {} : _c;
    return (React.createElement(Dialog, { fullScreen: true, keepMounted: keepMounted, open: open, onClose: onClose },
        React.createElement(AppBar, { style: { position: 'relative' } },
            React.createElement(Toolbar, null,
                onBack && (React.createElement(IconButton, { color: "inherit", onClick: onBack },
                    React.createElement(BackIcon, null))),
                React.createElement(Typography, { variant: "h6", style: { flex: 1 } },
                    title,
                    subTitle && React.createElement(SubTitle, null, subTitle)),
                React.createElement(IconButton, { edge: "start", color: "inherit", onClick: onClose, "aria-label": "close", size: "large" },
                    React.createElement(CloseDialogIcon, null)))),
        React.createElement(DialogContent, __assign({ sx: {
                padding: {
                    xs: '24px 16px',
                    md: '32px 40px',
                },
            } }, contentProps), children)));
};
export default FullScreenDialog;
var templateObject_1;
